import React, { useState, useEffect } from 'react';
import axios from '../axiosConfig';

const ClientForm = ({ selectedClient, onAdd, onUpdate, onCancelEdit }) => {
  const [formData, setFormData] = useState({ name: '', email: '', company: '' });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (selectedClient) {
      setFormData({
        name: selectedClient.name || '',
        email: selectedClient.email || '',
        company: selectedClient.company || '',
      });
    } else {
      setFormData({ name: '', email: '', company: '' });
    }
  }, [selectedClient]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      if (selectedClient) {
        const response = await axios.put(`/clients/${selectedClient.id}/`, formData);
        if (response.status === 200) {
          onUpdate(response.data);
        } else {
          setError(`Unexpected response: ${response.status}`);
        }
      } else {
        const response = await axios.post(`/clients/`, formData);
        if (response.status === 201 || response.status === 200) {
          onAdd(response.data);
        } else {
          setError(`Unexpected response: ${response.status}`);
        }
      }

      setFormData({ name: '', email: '', company: '' });
    } catch (err) {
      console.error('Client save error:', err?.response || err);
      setError(err?.response?.data?.detail || 'Failed to save client');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-6 p-4 bg-gray-100 rounded-lg">
      <h3 className="text-xl font-bold mb-4">
        {selectedClient ? 'Edit Client' : 'Add New Client'}
      </h3>
      {error && <p className="text-red-500 mb-2">{error}</p>}
      <div className="mb-2">
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Name"
          required
          className="w-full p-2 border rounded"
        />
      </div>
      <div className="mb-2">
        <input
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          type="email"
          required
          className="w-full p-2 border rounded"
        />
      </div>
      <div className="mb-2">
        <input
          name="company"
          value={formData.company}
          onChange={handleChange}
          placeholder="Company"
          required
          className="w-full p-2 border rounded"
        />
      </div>
      <div className="flex space-x-2">
        <button
          type="submit"
          className={`px-4 py-2 rounded text-white ${
            selectedClient ? 'bg-blue-500 hover:bg-blue-600' : 'bg-green-500 hover:bg-green-600'
          }`}
        >
          {selectedClient ? 'Update' : 'Add'}
        </button>
        {selectedClient && (
          <button
            type="button"
            onClick={onCancelEdit}
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-black"
          >
            Cancel
          </button>
        )}
      </div>
    </form>
  );
};

export default ClientForm;